import { NgModule } from '@angular/core';
import { MeetingProviderPipe } from './meeting-provider.pipe';
import { NavigationModule } from '../sales-center-navigation/navigation.module';
import { UpdateConfirmationDialogComponent } from './components/update-confirmation-dialog/update-confirmation-dialog.component';
import { DatePickerNavigationDirective } from './date-picker-navigation.directive';
import { CalendarDatePickerComponent } from './components/calendar-date-picker/calendar-date-picker.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

@NgModule({
  imports: [
    NavigationModule,
    TranslateModule,
    MatDialogModule,
    MatDatepickerModule,
    MatInputModule,
    CommonModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    GalaxyButtonLoadingIndicatorModule,
    GalaxyFormFieldModule,
    DatePickerNavigationDirective,
  ],
  declarations: [MeetingProviderPipe, UpdateConfirmationDialogComponent, CalendarDatePickerComponent],
  exports: [MeetingProviderPipe, DatePickerNavigationDirective, CalendarDatePickerComponent],
})
export class MeetingSchedulerSharedModule {}
